import React, { Component } from 'react'
import Nav from './Nav';
import Home from '../components/Home';
import Login from '../components/Login';
import Register from '../components/Register';
import Forget from '../components/Forget';
import Profile from '../components/Profile';
import Reset from '../components/Reset';
import axios from 'axios';

import {
     BrowserRouter as Router, Switch, Route, Link, Routes, BrowserRouter
} from "react-router-dom";

class Header extends Component {

     state = {
          user: {}
     }

     componentDidMount() {
          // Login User Credentials 
          axios.get('/user')
               .then((response) => {
                    this.setUser(response.data)
               })
               .catch((error) => {
                    console.log(error);
               });
     }

     setUser = (user) => {
          this.setState({ user: user })
     }


     render() {
          return (


               <BrowserRouter>
                    <div>


                         <Nav user={this.state.user} setUser={this.setUser} />

                         <Routes>
                              <Route exact path="/" element={<Home />} />
                              <Route exact path="/login" element={<Login user={this.state.user} setUser={this.setUser} />} />
                              <Route exact path="/register" element={<Register user={this.state.user} setUser={this.setUser} />} />
                              <Route exact path="/forget" element={<Forget />} />
                              <Route exact path="/reset/:token" element={<Reset />} />
                              <Route exact path="/profile" element={<Profile user={this.state.user} />} />

                         </Routes>

                    </div>
               </BrowserRouter>

          )
     }
}

export default Header
